export default "__VITE_ASSET__CQSYJ8yp__";